import 'slick-carousel';

const navCarousel = $('.js-animated-tab-navigation');
const tabCarousel = $('.js-animated-tabs');

$(document).ready(() => {
  if (!navCarousel.length || !tabCarousel.length) return;
  initCarousels();

  $(window).resize(() => {
    initCarousels();
  });
});

function initCarousels() {
  if (matchMedia('(max-width: 991px)').matches
  && !navCarousel.hasClass('slick-initialized')
  && !tabCarousel.hasClass('slick-initialized')) {
    navCarousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      variableWidth: false,
      infinite: true,
      speed: 700,
      fade: false,
      cssEase: 'ease',
      arrows: true,
      asNavFor: tabCarousel,
      prevArrow: '<div class="nav-button prev"><i class="fa fa-chevron-left"></div>',
      nextArrow: '<div class="nav-button next"><i class="fa fa-chevron-right"></div>',
    });

    // navCarousel.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
    //   // const tabIndexToSetActive = $(slick.$slides[nextSlide]).find('[data-tab-toggle]')
    //   //   .data('tab-toggle');
    //   //
    //   // $('[data-tab-id]').removeClass('active');
    //   // $(`[data-tab-id='${tabIndexToSetActive}']`).addClass('active');
    // });

    tabCarousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      variableWidth: false,
      infinite: true,
      speed: 700,
      fade: false,
      asNavFor: navCarousel,
      cssEase: 'ease',
      arrows: false,
      dots: true,
    });
  }

  if (matchMedia('(min-width: 991px)').matches
  && navCarousel.hasClass('slick-initialized')
  && navCarousel.hasClass('slick-initialized')) {
    navCarousel.slick('unslick');
    tabCarousel.slick('unslick');
  }
}
